<template>
    <div class="quoting_block">
        Please wait whilst we generate quotes
    </div>
</template>
